/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_DemandsInputs */

const cs_clients_modules_demands = /** @type {(inputs: Clients_Modules_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky (kupující / nájemce)`)
};

const en_clients_modules_demands = /** @type {(inputs: Clients_Modules_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demands (buyer / tenant)`)
};

/**
* | output |
* | --- |
* | "Demands (buyer / tenant)" |
*
* @param {Clients_Modules_DemandsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_demands = /** @type {((inputs?: Clients_Modules_DemandsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_DemandsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_demands(inputs)
	return cs_clients_modules_demands(inputs)
});